// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const plusle: PokeData = {
  "id": 311,
  "name": "plusle",
  "height": 4,
  "weight": 42,
  "base_experience": 142,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "growl",
    "thunder-wave",
    "thunder",
    "agility",
    "quick-attack",
    "swift",
    "charm",
    "spark",
    "baton-pass",
    "encore",
    "charge",
    "helping-hand",
    "skill-swap",
    "fake-tears",
    "copycat",
    "last-resort",
    "switcheroo",
    "nasty-plot",
    "discharge",
    "electro-ball",
    "entrainment",
    "bestow",
    "play-nice",
    "nuzzle"
  ],
  "moves": [
    "growl",
    "thunder",
    "quick-attack",
    "volt-switch",
    "electric-terrain",
    "thunder-fang",
    "thunderbolt",
    "electric-wrath",
    "volt-crash",
    "thunder-shock",
    "wild-charge",
    "quick-tempo",
    "thunder-punch"
  ],
  "evolution_chain": {
    "id": 154,
    "item": null,
    "species": [
      {
        "name": "plusle",
        "order": 337,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 159,
    "ability_power": 142
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
